import { ReactNode } from 'react';

import {
  File,
  FileActions,
  FileImage,
  FileTitle,
} from 'shared_DEPRECATED/components/File';

type UploadedFileImagePropTypes = {
  contentType: string;
  name: string;
  children: ReactNode;
  src: string;
};

export const UploadedFileImage = ({
  contentType,
  name,
  children,
  src,
}: UploadedFileImagePropTypes) => (
  <File>
    <FileImage src={src} />
    <FileTitle title={name} contentType={contentType} />
    <FileActions>{children}</FileActions>
  </File>
);
